import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import dados from './dados/store'
// import axios from 'axios'


Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import './plugins/axios'

// axios.defaults.headers.get['header-name'] = 'value'

Vue.use('VueRouter')

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)



new Vue({
  dados,
  router,
  render: h => h(App)
}).$mount('#app')